import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BoardServiceService } from '../../services/board-service.service';
import { first } from 'rxjs/operators';
import { UtilsService } from 'src/app/core/service/utils.service';

@Component({
  selector: 'app-task-history',
  templateUrl: './task-history.component.html',
  styleUrls: ['./task-history.component.scss']
})
export class TaskHistoryComponent implements OnInit {
  @Input() taskId: number = 0;

  pageSize: number = 20;
  page: number = 1;
  moreThan40: boolean = false;
  historyList: any = [];
  count: number = 0;


  constructor(
    private boardService: BoardServiceService,
    public translateService: TranslateService,
    protected utilSrv: UtilsService
  ) { }

  ngOnInit(): void {
    this.loadHistory();
  }

  loadHistory() {
    this.page = 1;
    this.historyList = [];
    this.count = 0;
    if (this.taskId != null && this.taskId != 0) {
      this.boardService.getHistory(this.taskId, this.pageSize, this.page).pipe(first()).subscribe((response) => {
        this.historyList = [];
        this.historyList = response.data;
        this.count = response.metadata.count;
      }, error => this.utilSrv.toast(`${this.translateService.instant('HISTORY.ERRORGET')}: ${error}`, 'error', false));
    }

  }
  loadMoreHistory() {
    if (this.taskId != null && this.taskId != 0) {
      this.boardService.getHistory(this.taskId, this.pageSize, this.page).pipe(first()).subscribe((response) => {
        let data = response.data;
        for (let x in data) {
          this.historyList.push(data[x]);
        }
      }, error => this.utilSrv.toast(`${this.translateService.instant('HISTORY.ERRORGET')}: ${error}`, 'error', false));
    }
  }

  onScrollDown() {
    this.page += 1;
    let sum = Number(this.page * this.pageSize);

    if (sum <= this.count + 20)
      this.loadMoreHistory();
  }

}
